
import { Button, Card, Form } from "react-bootstrap";

import "./login.scss";

import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoading, getRequestOTPData, getRequestOTPMsg, getVerifyOTPMsg } from "../../store/auth/selector";

import { useTimeout } from "../../hooks";

import * as authActions from "../../store/auth/actions";
import { getAppInfo, getGateConf } from "../../store/app/selector";
import { Redirect } from "react-router";
import { useTranslation, Trans } from "react-i18next"

const Login = () => {

    const { t } = useTranslation('translations');

    const [redirect, setRedirect] = useState(false)

    const requestOTPData = useSelector(state => getRequestOTPData(state));
    const requestOTPMessage = useSelector(state => getRequestOTPMsg(state));
    const verifyOTPMessage = useSelector(state => getVerifyOTPMsg(state));

    const isLoading = useSelector(state => getLoading(state));
    const appInfo = useSelector(state => getAppInfo(state));
    const gateConf = useSelector(state => getGateConf(state))


    const dispath = useDispatch();

    const [userid, setUserid] = useState(0);
    const [otp, setOTP] = useState(0);

    useTimeout(() => {
        if (appInfo === undefined) {
            setRedirect(true)
        }
    }, 1)

    const onGameIDChange = (event) => {
        setUserid(event.target.value);
    }

    const onOTPChange = (event) => {
        setOTP(event.target.value);
    }
    const onClickGetOTP = useCallback(() => {
        if (userid === 0) {
            return dispath(authActions.requestOTPError('The Game ID can not be blank!'))
        }
        dispath(authActions.requestOTP(userid, appInfo, gateConf.apiUrl));
    })

    const onClickVerifyOTP = useCallback(() => {
        if (otp === 0) {
            return dispath(authActions.verifyOTPError('The OTP can not be blank!'));
        }

        if (requestOTPData) {
            dispath(authActions.verifyOTP(requestOTPData.hash, otp, appInfo, gateConf.apiUrl));
        } else {
            dispath(authActions.requestOTPError('Please send to request OTP first!'));
            inputUserIDRef.current.focus();
        }

    })

    const inputUserIDRef = useRef(null);


    if (redirect) {

        return (
            <Redirect push to="/" />
        );
    }

    return (
        <>
            {appInfo &&
                <div id="login-form" className="d-flex justify-content-center h-100">
                    {isLoading && <div className="loading"></div>}
                    {/* <h4 className="game-title">{appname}</h4> */}
                    <Card>
                        <Card.Header>
                            <h3>{t("txt42")}</h3>
                        </Card.Header>
                        <Card.Body>
                            <Form>
                                <Form.Group>
                                    <Form.Label>{t("txt43")}</Form.Label>
                                    <Form.Control ref={inputUserIDRef} isInvalid={requestOTPMessage !== undefined} onChange={onGameIDChange} type="number" className="form-control" placeholder="Game ID..." />
                                    {requestOTPMessage !== undefined && <div className="invalid-feedback">{requestOTPMessage}</div>}
                                </Form.Group>

                                <Form.Group className="form-group">
                                    <Button className={isLoading ? "disable" : ""} type="button" onClick={() => onClickGetOTP()}>GET OTP</Button>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>
                                        <span className="first">{t("txt44")}</span>
                                        <span>
                                            {/* Don't have this Game? Please <a href={appInfo.apkUrl}>Download apk</a> */}
                                            <Trans

                                                i18nKey={'txt45'}
                                                ns="translations"
                                                values={{ link: appInfo.apkUrl}}
                                                components={{
                                                    userid: <a/>,
                                                }}
                                            />
                                        </span>
                                    </Form.Label>
                                    <Form.Label>{t("txt46")} </Form.Label>
                                    <Form.Control isInvalid={verifyOTPMessage !== undefined} onChange={onOTPChange} type="number" placeholder="OTP..." />
                                    {verifyOTPMessage !== undefined && <div className="invalid-feedback">{verifyOTPMessage}</div>}
                                </Form.Group>

                                <Form.Group className="form-group">
                                    <Button className={isLoading ? "disable" : ""} type="button" onClick={() => onClickVerifyOTP()}>SUBMIT</Button>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            }
        </>
    );
}

export default Login;